import { render, staticRenderFns } from "./BagsProductsTable.vue?vue&type=template&id=d513a9d0"
import script from "./BagsProductsTable.vue?vue&type=script&lang=js"
export * from "./BagsProductsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports